/* eslint-disable */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import {
  Box,
  Flex,
  HStack,
  Text,
  useColorModeValue,
  Icon,
} from "@chakra-ui/react";
import { loggedInUserState } from "atoms/loggedInUserState";
import { useRecoilValue } from "recoil";
import RoleBasedRender from "components/wrappers/roleBasedRender";

const Links = (props) => {
  const loggedInUser = useRecoilValue(loggedInUserState);
  const { onClose } = props;
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue("gray.800", "white");
  let inactiveColor = useColorModeValue("gray.600", "gray.400");
  let activeIcon = useColorModeValue("brand.500", "brand.500");
  let textColor = useColorModeValue("gray.600", "gray.400");
  let brandColor = useColorModeValue("brand.500", "brand.500");
  let activeBg = useColorModeValue(
    "rgba(35, 169, 121, 0.15)",
    "rgba(35, 169, 121, 0.25)",
  );
  let hoverBg = useColorModeValue(
    "rgba(35, 169, 121, 0.08)",
    "rgba(35, 169, 121, 0.15)",
  );
  let activeShadow = "0 4px 12px rgba(35, 169, 121, 0.2)";
  let hoverShadow = "0 4px 12px rgba(0, 0, 0, 0.05)";

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (route) => {
    if (location.pathname.length > route.length) {
      return location.pathname.includes(route + "/");
    } else {
      return location.pathname === route;
    }
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const links = routes.map((route, index) => {
    const locationPath = route.layout + route.path;
    const isActive = activeRoute(locationPath);
    if (route.layout === "/admin") {
      return (
        <RoleBasedRender roles={route?.roles} key={index}>
          <NavLink
            key={index}
            to={route.layout + route.path}
            width="100%"
            onClick={() => onClose && onClose()}
          >
            <Flex
              role="group"
              bg={isActive ? activeBg : "transparent"}
              borderRadius="lg"
              px={2.5}
              py={2.5}
              mb={2.5}
              justifyContent={"flex-start"}
              alignItems="center"
              w={"100%"}
              position="relative"
              transition="all 0.3s ease"
              boxShadow={isActive ? activeShadow : "none"}
              border={isActive ? "1px solid" : "1px solid transparent"}
              borderColor={isActive ? "rgba(35, 169, 121, 0.3)" : "transparent"}
              // backdropFilter={isActive ? "blur(8px)" : "none"}
              _hover={{
                bg: !isActive && hoverBg,
                transform: "translateX(5px)",
                boxShadow: !isActive && hoverShadow,
                borderColor: !isActive && "rgba(35, 169, 121, 0.1)",
              }}
            >
              <Flex
                alignItems={"center"}
                justifyContent={"center"}
                borderRadius="xl"
                bg={
                  isActive
                    ? "rgba(35, 169, 121, 0.2)"
                    : "rgba(35, 169, 121, 0.05)"
                }
                color={isActive ? activeIcon : textColor}
                h="34px"
                w="34px"
                me="11px"
                // transition="all 0.3s ease"
                // boxShadow={
                //   isActive ? "0 2px 8px rgba(35, 169, 121, 0.15)" : "none"
                // }
                border={"1px solid"}
                borderColor={
                  isActive ? "rgba(35, 169, 121, 0.3)" : "transparent"
                }
                _groupHover={{
                  bg: !isActive && "rgba(35, 169, 121, 0.1)",
                  color: !isActive && "brand.500",
                }}
              >
                {route.icon}
              </Flex>
              <Text
                color={isActive ? activeColor : textColor}
                fontWeight={isActive ? "600" : "500"}
                fontSize="14px"
                ml={1}
                // transition="all 0.3s ease"
                _groupHover={{
                  color: !isActive && "brand.500",
                }}
              >
                {route.name}
              </Text>
              {/* Removed the vertical bar indicator */}
            </Flex>
          </NavLink>
        </RoleBasedRender>
      );
    }
  });
  //  BRAND
  return [links];
};

export default Links;
